import { useEffect, useState } from "react";
import { fetchData } from "../../api";  
import { Link } from 'react-router-dom';

export default function Vacancies() {
    const [vacancies, setVacancies] = useState([]);
    const [titles, setTitles] = useState(null);

    useEffect(() => {
        fetchData("vacancies", true).then(data => setVacancies(data || []));
        fetchData("vacancy-titles", true).then(data => setTitles(data?.[0]));
    }, []);

    return (
        <section className="relative py-24 bg-gradient-to-br from-gray-50 via-white to-gray-100 overflow-hidden">
            {/* Background decorative elements */}
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_1px_1px,rgba(40,103,102,0.04)_1px,transparent_0)] bg-[length:40px_40px] pointer-events-none"></div>
            <div className="absolute top-10 left-10 w-72 h-72 bg-gradient-to-br from-[#286766]/10 to-transparent rounded-full blur-3xl"></div>
            <div className="absolute bottom-10 right-10 w-96 h-96 bg-gradient-to-tl from-[#27352C]/10 to-transparent rounded-full blur-3xl"></div>

            <div className="container mx-auto px-4 relative z-10">
                {/* Header Section */}
                <div className="text-center mb-20">
                    <h2 className="text-5xl md:text-6xl font-bold bg-gradient-to-r from-[#286766] via-[#27352C] to-[#286766] bg-clip-text text-transparent mb-6">
                        {titles?.VacancyTitle}
                    </h2>
                    <div className="w-24 h-1 bg-gradient-to-r from-[#286766] to-[#27352C] mx-auto rounded-full mb-8"></div>
                    <h4 className="text-lg text-gray-600 max-w-2xl mx-auto mb-2">{titles?.VacancyDescription}</h4>
                </div>

                {vacancies.length === 0 ? (
                    <div className="text-center p-8 bg-white/80 rounded-2xl shadow-xl max-w-xl mx-auto">
                        <h3 className="text-2xl font-semibold text-[#286766] mb-2">{titles?.NoVacancyTitle}</h3>
                        <p className="text-gray-600">{titles?.NoVacancyDescription}</p>
                    </div>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
                        {vacancies.map((vacancy, index) => (
                            <div
                                key={index}
                                className="relative bg-white/70 backdrop-blur-lg rounded-3xl shadow-2xl border border-gray-100 overflow-hidden transform transition-all duration-500 hover:scale-105 hover:shadow-3xl flex flex-col items-center text-center p-10"
                                style={{ animationDelay: `${index * 0.07}s`, animation: 'fadeInUp 0.6s ease-out forwards' }}
                            >
                                {/* Vacancy Icon/Image */}
                                <div className="w-20 h-20 flex items-center justify-center object-cover rounded-2xl mb-6 bg-gradient-to-br from-[#286766]/20 to-[#27352C]/10 shadow-lg">
                                    {vacancy.Image?.url ? (
                                        <img src={`${process.env.NEXT_PUBLIC_STRAPI_URL || "https://api.bouwbedrijfgeluk.nl"}${vacancy.Image?.url}`} alt={vacancy.Title} className="h-12 w-12 object-contain" />
                                    ) : (
                                        <svg className="w-12 h-12 text-[#286766]" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 11c0-1.104.896-2 2-2s2 .896 2 2-.896 2-2 2-2-.896-2-2zm0 0V7m0 4v4m0 0c0 1.104-.896 2-2 2s-2-.896-2-2 .896-2 2-2 2 .896 2 2z" /></svg>
                                    )}
                                </div>
                                <h3 className="text-2xl font-bold text-gray-900 mb-2">{vacancy.Title}</h3>
                                <p className="text-[#286766] font-medium mb-2 flex items-center justify-center gap-2">
                                    <svg className="w-5 h-5 inline-block text-[#286766]" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
                                    {vacancy.Location}
                                </p>
                                <p className="text-gray-700 mb-4 line-clamp-3">{vacancy.Description}</p>
                                <p className="text-sm text-gray-500 mb-4">Vereisten: {vacancy.Requirements}</p>
                                <Link
                                    to={vacancy?.BtnUrl}
                                    className="mt-auto inline-flex items-center gap-2 bg-gradient-to-r from-[#286766] to-[#27352C] text-white font-semibold py-3 px-8 rounded-xl hover:shadow-xl transition-all duration-300 transform hover:scale-105"
                                >
                                    {vacancy?.vacancyBtn || 'Solliciteer'}
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" /></svg>
                                </Link>
                            </div>
                        ))}
                    </div>
                )}
            </div>
            <style jsx>{`
                @keyframes fadeInUp {
                    from {
                        opacity: 0;
                        transform: translateY(30px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                .line-clamp-3 {
                    display: -webkit-box;
                    -webkit-line-clamp: 3;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                }
            `}</style>
        </section>
    );
}
